import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  input: {
    '& label': {
      transform: 'translate(0, 1.5px)',
      width: '100%',
      '& .label--required': {
        color: theme.palette.primary.main,
      },
      '& .label--icon-valid': {
        color: theme.palette.primary.main,
      },
    },
  },
  iconButton: {
    padding: '0 12px',
  },
  invalidIconButton: {
    color: '#FF3333',
  },
  labelBlock: {
    height: '16px',
  },
}));

export { useStyles };
